/*
 * Copyright OpenSearch Contributors
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 *  SPDX-License-Identifier: Apache-2.0
 *
 *  OpenSearch 贡献者要求对本文件的贡献遵循 Apache-2.0 许可证或兼容的开源许可证。
 *
 *  修改版权归 OpenSearch 贡献者所有。详情请查看 GitHub 历史记录。
 */

/*
 *  本文件已获得 Elasticsearch B.V. 根据一个或多个贡献者许可协议的授权。
 *  请查看随本工作分发的 NOTICE 文件，以获取有关版权所有权的更多信息。
 *  Elasticsearch B.V. 根据 Apache 许可证 2.0 版（“许可证”）将本文件授权给您；
 *  除非遵守许可证，否则您不得使用本文件。您可以在以下地址获取许可证副本：
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  除非适用法律要求或书面同意，否则根据许可证分发的软件按“原样”分发，
 *  不附带任何形式的明示或暗示的保证和条件。请参阅许可证以了解有关权限和限制的具体规定。
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { OuiPopover } from '../../../popover';
import { formatTimeString } from '../pretty_duration';
import { OuiDatePopoverContent } from './date_popover_content'; // eslint-disable-line import/named

export var OuiDatePopoverButton = props => {
  const {
    position,
    isDisabled,
    isInvalid,
    needsUpdating,
    value,
    buttonProps,
    roundUp,
    onChange,
    locale,
    dateFormat,
    utcOffset,
    timeFormat,
    isOpen,
    onPopoverToggle,
    onPopoverClose,
    compressed,
    ...rest
  } = props;
  const classes = classNames(['ouiDatePopoverButton', `ouiDatePopoverButton--${position}`, {
    'ouiDatePopoverButton-isSelected': isOpen,
    'ouiDatePopoverButton-isInvalid': isInvalid,
    'ouiDatePopoverButton-needsUpdating': needsUpdating,
    'ouiDatePopoverButton-disabled': isDisabled,
    'ouiDatePopoverButton-compressed': compressed
  }]);
  let title = value;

  if (isInvalid) {
    title = `无效日期: ${title}`;
  } else if (needsUpdating) {
    title = `需要更新: ${title}`;
  }

  const button = <button onClick={onPopoverToggle} className={classes} title={title} disabled={isDisabled} data-test-subj={`superDatePicker${position}DatePopoverButton`} {...buttonProps}>
      {formatTimeString(value, dateFormat, roundUp, locale)}
    </button>;
  return <OuiPopover button={button} isOpen={isOpen} closePopover={onPopoverClose} anchorPosition={position === 'start' ? 'downLeft' : 'downRight'} display="block" panelPaddingSize="none" {...rest}>
      <OuiDatePopoverContent value={value} roundUp={roundUp} onChange={onChange} dateFormat={dateFormat} timeFormat={timeFormat} locale={locale} position={position} utcOffset={utcOffset} />
    </OuiPopover>;
};
OuiDatePopoverButton.propTypes = {
  className: PropTypes.string,
  buttonProps: PropTypes.any,
  dateFormat: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  needsUpdating: PropTypes.bool,
  locale: PropTypes.any,
  onChange: PropTypes.any.isRequired,
  onPopoverClose: PropTypes.any.isRequired,
  onPopoverToggle: PropTypes.func.isRequired,
  position: PropTypes.oneOf(["start", "end"]).isRequired,
  roundUp: PropTypes.bool,
  timeFormat: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  utcOffset: PropTypes.number,
  compressed: PropTypes.bool
};
OuiDatePopoverButton.displayName = 'OuiDatePopoverButton';